import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { addRolesApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const addRoleApi = createAsyncThunk('addRoleApi', async (payload) => {
  return await addRolesApi(payload);
});

const addRolesSlice = createSlice({
  name: 'addRoles', // Unique Name
  initialState,
  reducers: {
    addRolesReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addRoleApi.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(addRoleApi.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(addRoleApi.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { addRolesReset } = addRolesSlice.actions;

export default addRolesSlice.reducer;
